export const SET_ADDON_EMAIL = "SET_ADDON_EMAIL";

export const setAddOnEmail = (payload) => ({
	type: SET_ADDON_EMAIL,
	payload,
});
